import gql from 'graphql-tag';

export const GET_MEMBER_LIST = gql`

    query ($name: String, $member_no: ID, $golf_group_code: String, $golf_code: String, $birth_date: String, $mobile_number: String, $begin_row: Int, $limit_rows: Int, $card_no: String, $message_completed: Boolean) {
        getMemberList(name: $name, member_no: $member_no, golf_group_code: $golf_group_code, golf_code: $golf_code, birth_date: $birth_date, mobile_number: $mobile_number, begin_row: $begin_row, limit_rows: $limit_rows, card_no: $card_no, message_completed: $message_completed)
        {
            MemberList {
                member_no
                family_name
                given_name
                gender
                birth_date
                mobile_number
                point
                member_class_name
                member_rank
            }
            count
        }
    },

`;
export const GET_GOLFGROUP = gql`
    query {
        golfGroup{
            golf_group_code
            golf_group_name
            point_use_type
        }
    }
`;

export const MEMBER_LIST_INITIAL_DISPLAY = gql`
    query ( $golf_group_code: String! ){
        getGolfGroupByMaster{
            golf_group_code
            golf_group_name
            point_use_type
            point_remainder_type
            point_type_name
            remainder
        }
        getGolfCourse (golf_group_code: $golf_group_code) {
            golf_code
            golf_name
        }
    }
`;
